app.formVisitorsDay = {

    settings: {
        formSelector: '#form-visitors-day',
        $form : $('#form-visitors-day')
    },

    init: function() {
        app.formVisitorsDay.settings.$form.on('submit', app.formVisitorsDay.submit);
    },

    submit: function(ev){

        ev.preventDefault();

        context.submit({
            method: "submitVisitorsdayform",
            form: app.formVisitorsDay.settings.formSelector,
            onSuccess: function(response){

                app.formVisitorsDay.showSuccess();
                app.formVisitorsDay.clearForm();

                window.location.href = response.returnUrl;
            },
            onError: function(){
                app.formVisitorsDay.showError();
            }
        });
    },

    showSuccess: function() {
        app.formVisitorsDay.settings.$form.find('.btn').removeClass('btn--delta icon--paper-plane btn--epsilon icon--spinner').addClass('btn--dota icon--check').html('Succesvol verzonden');
    },

    showError: function() {
        alert("Er is iets misgegaan. Probeer het later nog eens of neem contact met ons op.");
    },

    clearForm: function(){
        app.formVisitorsDay.settings.$form.find("input").val("");
    }
};